

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';

export class BaseDocument extends BaseEntity
{   
    public DocumentNumber: number; 
    public SBODocumentEntry: number; 
    public CustomerID: number; 
    public ContactPersonID: number; 
    public TransType: number; 
    public PdfUrl: string; 
    public DocumentCurrency: string; 
    public OpenSumOrigin: number; 
    public CurrencyOrigin: string; 
    public CountFiles: number; 
    public CompanyID: number; 
    public PaymentSum: number; 
    public PaymentCurrency: string; 
    public TransTypeString: string; 
	
}



